if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        this.counterCurrent = this.querySelector('.product-media-modal__counter-current');
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');

        if (this.prevButton) this.prevButton.addEventListener('click', () => this.step(-1));
        if (this.nextButton) this.nextButton.addEventListener('click', () => this.step(1));

        this.addEventListener('keyup', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft') this.step(-1);
          if (event.key === 'ArrowRight') this.step(1);
        });

        // ModalDialog closes the modal on any pointerup that isn't inside
        // deferred-media/product-model (its "click outside the image to
        // close" behavior). The nav bar sits outside that content, so
        // without this it closes the modal every time prev/next is clicked.
        const mobileBar = this.querySelector('.product-media-modal__mobile-bar');
        if (mobileBar) {
          mobileBar.addEventListener('pointerup', (event) => event.stopPropagation());
        }

        const content = this.querySelector('.product-media-modal__content');
        if (content) {
          let touchStartX = 0;
          let touchStartY = 0;
          content.addEventListener(
            'touchstart',
            (event) => {
              touchStartX = event.touches[0].clientX;
              touchStartY = event.touches[0].clientY;
            },
            { passive: true }
          );
          content.addEventListener(
            'touchend',
            (event) => {
              const deltaX = event.changedTouches[0].clientX - touchStartX;
              const deltaY = event.changedTouches[0].clientY - touchStartY;
              if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
                this.step(deltaX < 0 ? 1 : -1);
              }
            },
            { passive: true }
          );
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      step(direction) {
        if (!this.mediaItems.length) return;
        const currentIndex = this.mediaItems.findIndex((el) => el.classList.contains('active'));
        const nextIndex =
          (currentIndex + direction + this.mediaItems.length) % this.mediaItems.length;
        this.activateMedia(this.mediaItems[nextIndex]);
      }

      activateMedia(activeMedia) {
        if (window.pauseAllMedia) window.pauseAllMedia();

        this.mediaItems.forEach((element) => element.classList.remove('active'));
        activeMedia.classList.add('active');

        if (this.counterCurrent) {
          const index = this.mediaItems.indexOf(activeMedia);
          this.counterCurrent.textContent = index + 1;
        }

        // Video/model/external-video content lives inert inside a <template>
        // until loadContent() clones it into the DOM - without this, videos
        // (not just YouTube embeds) show as a blank frame instead of the
        // poster/player, and never autoplay when navigated to.
        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && typeof activeMedia.loadContent === 'function') {
          activeMedia.loadContent();
        }
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (activeMedia) this.activateMedia(activeMedia);
      }
    }
  );
}
